import { useCallback, useEffect, useRef, useState } from 'react';
import * as api from '../api/raContactChat';
export function useContactChatInbox(scopeKey:string,enabled:boolean) {
 const [data, setData] = useState<{scope:string;items:api.ContactConversation[];count:number}>({scope:scopeKey,items:[],count:0});
 const epoch = useRef(0);
 // The slot belongs to an epoch, so an invalidated request cannot release a replacement request.
 const inFlight = useRef<number | null>(null);
 const refresh = useCallback(async () => {
  if (!enabled || inFlight.current !== null) return;
  const generation = epoch.current;
  inFlight.current = generation;
  try {
   const result = await api.listContactChats();
   if (epoch.current === generation) setData({scope:scopeKey,items:result.conversations,count:result.unread_count});
  } catch (error) {
   if (epoch.current === generation && error instanceof api.ContactChatError && [401,403].includes(error.status)) {
    setData({scope:scopeKey,items:[],count:0});
   }
  } finally {
   if (inFlight.current === generation) inFlight.current = null;
  }
 }, [enabled, scopeKey]);
 useEffect(() => {
  const clear = () => {
   epoch.current += 1;
   inFlight.current = null;
   setData({scope:scopeKey,items:[],count:0});
  };
  clear();
  void refresh();
  const visible = () => { if (document.visibilityState === 'visible') void refresh(); };
  window.addEventListener('focus', visible);
  document.addEventListener('visibilitychange', visible);
  window.addEventListener('contact-chat:changed', visible);
  const timer = enabled ? window.setInterval(visible, 30000) : undefined;
  window.addEventListener('auth-expired', clear);
  return () => {
   epoch.current += 1;
   inFlight.current = null;
   window.removeEventListener('focus', visible);
   document.removeEventListener('visibilitychange', visible);
   window.removeEventListener('contact-chat:changed', visible);
   window.removeEventListener('auth-expired', clear);
   window.clearInterval(timer);
  };
 }, [scopeKey, enabled, refresh]);
 return {conversations:enabled&&data.scope===scopeKey?data.items:[],unreadCount:enabled&&data.scope===scopeKey?data.count:0,refresh};
}
